import { useState, useEffect } from 'react';
import { baseurladdress } from '../baseurl';
import axios from 'axios';
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import $ from 'jquery';

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";


export default function Regionlist() {
    const accesstoken = localStorage.getItem("token");
const accessuserid = localStorage.getItem("id");
const Swal = require('sweetalert2')
    let navigate = useNavigate();

    const [data, setData] = useState([]);
    const [showModal, setShow] = useState(false);
    const [agreeToStatus, setagreeToStatus] = useState("");


    const [regioncode, setregioncode] = useState("");
    const [regionname, setregionname] = useState("");
    const [regionstatus, setregionstatus] = useState("");
    const [id, setid] = useState("");




    const editRegion = (id) => {
        console.log("id" + id);
        setid(id);

        setShow(true);
        const data = {
            region_id: id
        }
        axios.get(
            baseurladdress + `editregion/` + id,
            {
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        )
            .then((response) => {
                const data = response.data.response;
                console.log(data);
                setregioncode(data[0].region_code);
                setregionname(data[0].region_name);
                setregionstatus(data[0].region_status);
            }, [id]
            );
    }
    
    const closeregion = (event) => {
        event.preventDefault();
        setShow(false);
    }



    useEffect(() => {
        const getRegions = () => {
            axios
                .get(baseurladdress + `getallregions`, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then(res => {
                    const datas = res.data.response;
                    // console.log("itemss" + datas);
                    const user = datas.map((item, index) => (

                        <tr style={{ textAlign: "center" }}  >

                            <td>{item.region_code}</td>
                            <td>{item.region_name}</td>
                            <td style={{ "textAlign": "center" }} >        <div>
                                {(() => {
                                    if (item.region_status == 1) {
                                        return (
                                            <div>
                                                <span class="badge bg-success" >
                                                    Active
                                                </span>
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div>
                                                <span class="badge bg-danger" >
                                                    Inactive
                                                </span>
                                            </div>
                                        );
                                    }
                                })()}
                            </div></td>
                            <td style={{ "textAlign": "center" }}>
                                <a class="inline-block tbnss" 
                                    onClick={() => editRegion(item.region_id)}
                                >
                                    <i class="text-primary fa fa-edit"></i>
                                </a>
                            </td>
                            {/* 
                            <td></td> */}
                        </tr>
                    ));

                    setData(user);
                })
                .catch(error => {
                    alert(error);
                })
        }
        getRegions()

    }, [])


    const handleSubmit = () => {

        var data = {
            region_code: regioncode,
            region_name: regionname,
            region_status: regionstatus,
            region_id: id
        };
        fetch(baseurladdress + "updateregion", {
            method: "POST",
            headers: {
                Accept: "application/form-data",
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
            body: JSON.stringify(data),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "updated") {

                    //alert("Branch added successfully");

                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'success',
                        title: 'Region updated successfully'
                    })
                    setShow(false);
                    window.location.reload();
                    navigate("/branchlist");
                }
            });
    };
    $(function () {
        setTimeout(function () {
            $('#regionlist').DataTable();
        }, 1000);
    });


    return (
        <>
            <div className="col-lg-12">
                <div className="card">

                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-bordered table-responsive-sm" id='regionlist'>
                                <thead>
                                    <tr>

                                        <th style={{ "textAlign": "center" }}>Region Code</th>
                                        <th style={{ "textAlign": "center" }}>Region Name</th>
                                        <th style={{ "textAlign": "center" }}>Status</th>
                                        <th style={{ "textAlign": "center" }}>Edit</th>
                                        {/* <th style={{ "textAlign": "center" }}>Delete</th> */}

                                    </tr>
                                </thead>
                                <tbody>
                                    {data}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={showModal} >

                <Modal.Header>
                    <h5 >UPDATE REGION</h5>
                </Modal.Header>
                <Modal.Body>
                    <form encType="multipart/form-data">
                        <div className="form-group row">

                            <div className="col-md-12">
                                <h6>Region name </h6>
                                <input type="text" class="form-control"
                                    onChange={(e) => setregionname(e.target.value)}
                                    value={regionname}
                                    required />
                            </div>
                            <div className=" col-md-6">
                                <h6> Code </h6>
                                <input type="text" class="form-control"
                                    onChange={(e) => setregioncode(e.target.value)}
                                    value={regioncode}
                                    required />
                            </div>
                            <div className="col-md-6">
                                <h6>Status </h6>
                                <select
                                    className="form-control select"
                                    name="user_status"
                                    id="user_status"
                                    placeholder="Enter user_status"
                                    value={regionstatus}
                                    onChange={(e) => setregionstatus(e.target.value)}
                                >


                                    <option value="1" selected={(regionstatus == "1") ? "selected" : ""}>Active</option>
                                    <option value="0" selected={(regionstatus == "0") ? "selected" : ""}>Inactive</option>

                                </select>

                            </div>
                        </div>
                        <Modal.Footer>
                            <button
                                className="button1 btn btn-success"
                                type="button"
                                onClick={() => handleSubmit()}
                            >
                                UPDATE
                            </button>
                            <Button
                                className="button1"
                                variant="danger"
                                onClick={closeregion}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </form>

                </Modal.Body>

            </Modal>

        </>
    )
}
